export default {
  id: "machine-final-journey",
  pride: 27648,
  slug: "machine-final-journey",
  category: "game",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "机器终末旅行",
    en: "Machine's Final Journey"
  },
  bilibiliVideoId: "BV1xcXxYXEaw",
  date: { year: 2025, month: 3, day: 23 },
  descriptionKey: {
    zh: "以自由组装为核心机制的解谜+3D平台游戏。操作机器人收集并搭配功能各异的组件，发挥脑洞通关。7位应届生于腾讯IEG开普勒计划历时1个月开发完成，荣获Minigame银奖。",
    en: "A puzzle + 3D platformer built around free assembly. Control a robot, collect and combine components with different functions, and use your creativity to clear levels. Built in one month by 7 new graduates in Tencent IEG's Kepler Program. Won the Minigame Silver Award."
  },
  genres: ["解谜", "平台", "3D"],
  themes: ["机器人", "组装"],
  platform: ["PC"],
  achievements: [
    { zh: "腾讯开普勒计划 Minigame 银奖", en: "Tencent Kepler Program Minigame Silver Award" }
  ],
  developerNotesKey: {
    zh: "腾讯IEG开普勒计划作品，7人应届生团队，1个月完成。核心玩法是自由组装机器人组件，脑洞解谜。",
    en: "Tencent IEG Kepler Program project. 7-person new-grad team, completed in one month. Core mechanic: freely assemble robot components to solve puzzles."
  },
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1xcXxYXEaw/", textKey: { zh: "游戏 PV", en: "Game PV" } },
    { type: "download", url: "https://pan.baidu.com/s/1sw405fCWIYSRn9rjbEZFkg?pwd=2w59", textKey: { zh: "Demo 下载（提取码 2w59）", en: "Demo Download (code: 2w59)" } }
  ]
};
